const CACHE_KEY = 'musicsite:public-settings-v2';

const PUBLIC_FIELDS = [
  'siteName',
  'siteDescription',
  'siteUrl',
  'favicon',
  'socialImage',
  'contactEmail',
  'defaultLanguage',
  'timeZone',
  'enableBookings',
  'enableLessons',
  'maintenanceMode',
  'maxUploadSize',
  'pageContent',
  'themeColors'
];

export const readCachedPublicSettings = () => {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

export const writeCachedPublicSettings = (data) => {
  if (!data) return;

  try {
    const payload = {};
    PUBLIC_FIELDS.forEach((field) => {
      if (data[field] !== undefined) {
        payload[field] = data[field];
      }
    });
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(payload));
  } catch (err) {
    // Ignore quota / private-mode errors.
  }
};

export const readBootstrapBrandingFromDocument = () => {
  const siteName = document.querySelector('meta[property="og:site_name"]')?.getAttribute('content')?.trim();
  if (!siteName) return null;

  const siteDescription = document.querySelector('meta[name="description"]')?.getAttribute('content')?.trim();

  return {
    siteName,
    siteDescription: siteDescription || undefined
  };
};
